import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import "../../assets/styles/Card.css";

export default function Card({ titulo, info, children, size = "medium", className, startCollapsed = false }) {
  const [expandido, setExpandido] = useState(!startCollapsed)
  return (
    <div className={`card ${size} ${className} ${expandido ? "expandido" : "colapsado"}`}>
      <div className="card-header" onClick={() => setExpandido(!expandido)}> 
        {titulo && <h3>{titulo}</h3>}
        <button className="toggle-btn">
          {expandido ? <FiChevronUp /> : <FiChevronDown />}
        </button>
      </div>
      {expandido && info && <p className="card-info">{info}</p>}
      {expandido && children && <div className="card-actions card-body">{children}</div>}
    </div>
  );
}
